<div class="pie-chart-main">
  <div class="lw-container" #graph>
    @if (loading) {
      <lds-progress-spinner></lds-progress-spinner>
    }
  </div>
</div>

